import { render, staticRenderFns } from "./LoginSanctum.vue?vue&type=template&id=42b0f058&scoped=true"
import script from "./LoginSanctum.vue?vue&type=script&lang=js"
export * from "./LoginSanctum.vue?vue&type=script&lang=js"
import style0 from "./LoginSanctum.vue?vue&type=style&index=0&id=42b0f058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b0f058",
  null
  
)

export default component.exports